import Root from './Root';
Root.displayName = 'ShineoutMenu';
export default Root;